// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTreatmentSummary_root__3sKsF","row":"ProcedureTreatmentSummary_row__2TZJ_"};